const fonts = [
  { value: null, labelKey: 'shared.fonts.placeholder' },
  { value: 'nCrypto1', labelKey: 'shared.fonts.numbers', n: 1 },
  { value: 'nCrypto2', labelKey: 'shared.fonts.numbers', n: 2 },
  { value: 'nCrypto3', labelKey: 'shared.fonts.numbers', n: 3 },
  { value: 'nCrypto4', labelKey: 'shared.fonts.numbers', n: 4 },
  { value: 'nCrypto10', labelKey: 'shared.fonts.numbers', n: 10 },
  { value: 'nCrypto11', labelKey: 'shared.fonts.numbers', n: 11 },
  { value: 'Crypto1', labelKey: 'shared.fonts.symbols', n: 1 },
  { value: 'Crypto2', labelKey: 'shared.fonts.symbols', n: 2 },
  { value: 'Crypto3', labelKey: 'shared.fonts.symbols', n: 3 },
  { value: 'Crypto4', labelKey: 'shared.fonts.symbols', n: 4 },
  { value: 'Font-crypto-1', labelKey: 'shared.fonts.fontCrypto', n: 1 },
  { value: 'Font-crypto-2', labelKey: 'shared.fonts.fontCrypto', n: 2 },
  { value: 'Font-crypto-3', labelKey: 'shared.fonts.fontCrypto', n: 3 },
  { value: 'Font-crypto-4', labelKey: 'shared.fonts.fontCrypto', n: 4 },
  { value: 'Font-crypto-5', labelKey: 'shared.fonts.fontCrypto', n: 5 },
  { value: 'Font-crypto-6', labelKey: 'shared.fonts.fontCrypto', n: 6 },
  { value: 'Font-crypto-7', labelKey: 'shared.fonts.fontCrypto', n: 7 },
  { value: 'Font-crypto-8', labelKey: 'shared.fonts.fontCrypto', n: 8 },
  { value: 'Font-crypto-9', labelKey: 'shared.fonts.fontCrypto', n: 9 },
  { value: 'Font-crypto-10', labelKey: 'shared.fonts.fontCrypto', n: 10 },
  { value: 'Font-crypto-11', labelKey: 'shared.fonts.fontCrypto', n: 11 },
  { value: 'Font-crypto-12', labelKey: 'shared.fonts.fontCrypto', n: 12 },
  { value: 'Font-crypto-13', labelKey: 'shared.fonts.fontCrypto', n: 13 },
  { value: 'Font-crypto-14', labelKey: 'shared.fonts.fontCrypto', n: 14 },
  { value: 'Font-crypto-15', labelKey: 'shared.fonts.fontCrypto', n: 15 },
  { value: 'Font-crypto-16', labelKey: 'shared.fonts.fontCrypto', n: 16 },
  { value: 'Font-crypto-17', labelKey: 'shared.fonts.fontCrypto', n: 17 },
  { value: 'Font-crypto-18', labelKey: 'shared.fonts.fontCrypto', n: 18 },
  { value: 'Font-crypto-19', labelKey: 'shared.fonts.fontCrypto', n: 19 },
  { value: 'Font-crypto-20', labelKey: 'shared.fonts.fontCrypto', n: 20 },
  { value: 'Font-crypto-21', labelKey: 'shared.fonts.fontCrypto', n: 21 },
  { value: 'Font-crypto-22', labelKey: 'shared.fonts.fontCrypto', n: 22 },
  { value: 'Font-crypto-23', labelKey: 'shared.fonts.fontCrypto', n: 23 },
  { value: 'Font-crypto-24', labelKey: 'shared.fonts.fontCrypto', n: 24 },
  { value: 'Font-crypto-25', labelKey: 'shared.fonts.fontCrypto', n: 25 },
  { value: 'Font-crypto-26', labelKey: 'shared.fonts.fontCrypto', n: 26 },
  { value: 'Font-crypto-27', labelKey: 'shared.fonts.fontCrypto', n: 27 },
  { value: 'Font-crypto-28', labelKey: 'shared.fonts.fontCrypto', n: 28 },
  { value: 'Font-crypto-29', labelKey: 'shared.fonts.fontCrypto', n: 29 },
  { value: 'Font-crypto-30', labelKey: 'shared.fonts.fontCrypto', n: 30 },
];

export default fonts;
